<template>
  <button
    class="flex disabled:cursor-normal focus:outline-none bg-background-primary border border-border px-s12 py-s16 rounded-16 subheadline-medium items-center"
    @click="$emit('click')">
    <slot />
  </button>
</template>
<script>
export default {
  name: 'KycCountryButton'
};
</script>
<style scoped></style>
